import React from 'react'
import { useLocation } from 'react-router-dom';
import './Destination.css'
import NavBar from '../Components/NavBar';
import Footer from '../Components/Footer';
import SeoMeta from '../Components/SeoMeta';

function Destination() {
  const location = useLocation();
  const canonicalUrl = `https://www.nimantrana.co.in${location.pathname || '/destination'}`;
  const destinationSchema = {
    "@context": "https://schema.org",
    "@type": "Resort",
    "name": "MOHA by Nimantrana",
    "url": canonicalUrl,
    "description": "Retreat to MOHA by Nimantrana, a riverside sanctuary in Rishikesh with immersive nature experiences and curated hospitality.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Mohanchatti",
      "addressRegion": "Uttarakhand",
      "addressCountry": "IN"
    },
    "image": [
      "https://nimantrana-media.s3.ap-south-1.amazonaws.com/destination1.jpeg",
      "https://nimantrana-media.s3.ap-south-1.amazonaws.com/destination2.jpeg",
      "https://nimantrana-media.s3.ap-south-1.amazonaws.com/destination3.png"
    ]
  };

  const handleDirections = () => {
    window.open('https://www.google.com/maps?q=30.060762405395508,78.3885498046875&z=17&hl=en', '_blank');
  };

  return (
    <div className="moha1">
      <SeoMeta
        title="Rishikesh Riverside Retreat | MOHA by Nimantrana"
        description="Retreat to MOHA by Nimantrana in Rishikesh for riverside tranquility, curated experiences, and boutique hospitality."
        canonical={canonicalUrl}
        keywords="Rishikesh resort, riverside stay, MOHA by Nimantrana, boutique retreat"
        image="https://nimantrana-media.s3.ap-south-1.amazonaws.com/destination1.jpeg"
        structuredData={destinationSchema}
      />
      <NavBar/>

      {/* Hero Section */}
      <div className="moha2">
        <div className="moha3">
          <img src="/destination1.jpeg" alt="MOHA by Nimantran" />
          <div className="moha4">
            <div className="moha5">
              <h1 className="moha6">Moha by Nimantran</h1>
              <p className="moha7">Mohanchatti, Rishikesh</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="moha8">
        <div className="moha9">
          <div className="moha10">
            <h2>Riverside Tranquility</h2>
            <p>
              Nestled along the serene banks of the sacred river, MOHA by Nimantran offers an 
              unparalleled riverside experience. Wake up to the gentle sounds of flowing water 
              and immerse yourself in the peaceful river stream views that define our unique 
              location. Our riverside retreat provides the perfect blend of comfort and natural 
              beauty, where every moment is enhanced by the calming presence of the river bank.
            </p>
            <p>
              Experience the magic of riverside living with breathtaking river views from 
              every corner of our property. The tranquil riverside atmosphere creates an 
              ideal sanctuary for those seeking peace and rejuvenation.
            </p>
          </div>

          {/* Image Gallery */}
          <div className="moha11">
            <div className="moha12 moha13">
              <img src="/destination2.jpeg" alt="River view from MOHA" />
            </div>
            <div className="moha12">
              <img src="/destination3.png" alt="MOHA exterior" />
            </div>
          </div>

          {/* Direction Button */}
          <div className="moha14">
            <button className="moha15" onClick={handleDirections}>
              <span className="moha16">📍</span>
              Get Directions
            </button>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default Destination
